import script from "./lcBaseInfo.vue?vue&type=script&setup=true&name=lcBaseInfo&lang=js"
export * from "./lcBaseInfo.vue?vue&type=script&setup=true&name=lcBaseInfo&lang=js"

import "./lcBaseInfo.vue?vue&type=style&index=0&id=dd6fe69c&scoped=true&lang=scss"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd6fe69c"]])

export default __exports__